'use strict';

/**
 *
 * @name: addonSoundcloud
 *
 */

import DirectiveTemplate from './nn-addon-soundcloud.directive.html';
import './nn-addon-soundcloud.directive.scss';

function AddonSoundcloudDirective($sce) {

  'ngInject';

  return {
    restrict: 'C',
    replace: true,
    template: DirectiveTemplate,
    link: function(scope, element, attrs) {

      scope.soundcloudSettings = {
        item: null
      };

      scope.post.media.some(function(item) {

        if (item.key === attrs.mediaKey) {

          scope.soundcloudSettings.item = item;
          return true;
        }
        return false;
      });

      var trustedResource = 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/' +
        scope.soundcloudSettings.item.content +
        '&amp;amp;color=8B7C3C&amp;amp;auto_play=false&amp;amp;hide_related=true&amp;amp;show_artwork=false';

      scope.soundcloudSettings.source = $sce.trustAsResourceUrl(trustedResource);

    }
  };
}

export default AddonSoundcloudDirective;



// WEBPACK FOOTER //
// ./app/components/nn-add-ons/nn-addon-soundcloud/nn-addon-soundcloud.directive.js